import { useState } from 'react'

import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'

import { SelectOrganisation } from './SelectOrganisation'

import { useServices } from '@percent/product-nomination-form/hooks'
import { useQuery } from '@percent/utility'

const ORGANISATION_SEARCH_PAGE_SIZE = 25

export const SelectOrganisationContainer = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const { country } = useValidationStepData()
  const { organisationsService } = useServices()

  const {
    data: organisationsData,
    error: organisationsError,
    isLoading: isOrganisationsLoading,
  } = useQuery(
    ['organisations', searchQuery, country],
    organisationsService.getOrganisations,
    {
      query: searchQuery,
      countryCode: country,
      pageSize: ORGANISATION_SEARCH_PAGE_SIZE,
    },
    {
      retry: false,
      shallowData: true,
    }
  )

  return (
    <SelectOrganisation
      data={organisationsData}
      isLoading={isOrganisationsLoading}
      setSearchQuery={setSearchQuery}
      isError={!!organisationsError}
      country={country}
    />
  )
}
